<ng-container [formGroup]="form">
  <div class="d-flex flex-direction-column">
    <mat-form-field class="form-input form-input_number filter-field m-0">
      <mat-label>{{config.title}}</mat-label>
      <input [formControlName]="controlName"
             [attr.data-test-id]="controlName+'-input'"
             [digitsAfterDot]="config.digitsAfterDot"
             [numeric]="true"
             [allowFloat]="!!config.digitsAfterDot"
             [max]="config.maxValue"
             [min]="config.minValue"
             [attr.max]="config.maxValue"
             [attr.min]="config.minValue"
             [placeholder]="config.placeholder"
             [attr.type]="config.digitsAfterDot ? 'text' : 'number'"
             class="input"
             matInput
             autocomplete="off">
      <button *ngIf="control?.value"
              (click)="clearField(control, $event)"
              [attr.data-test-id]="controlName+'-clear'"
              class="p-0"
              mat-button
              matSuffix
              mat-icon-button
              aria-label="Clear">
        <mat-icon>close</mat-icon>
      </button>
      <mat-error>{{getError(control, config.errors)}}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
